import { useEffect, useState } from "react";
import { Show, useAuth } from "@clerk/react";
import { Navigate, Link, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import { publicApi } from "@/lib/api";

function CategoryCard({ cat }) {
  return (
    <Link to={`/category/${cat.id}`} data-testid={`category-card-${cat.slug}`}
      className="sticker-card overflow-hidden block">
      <div className="h-40 w-full overflow-hidden border-b-[3px] border-[#374151] bg-slate-100">
        {cat.image && <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" />}
      </div>
      <div className="p-5">
        <h3 className="text-xl font-black tracking-tight">{cat.name}</h3>
        <p className="text-slate-600 mt-1">{cat.description}</p>
      </div>
    </Link>
  );
}

export default function Dashboard() {
  const [cats, setCats] = useState([]);
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();
  useEffect(() => { publicApi.get("/categories").then((r) => setCats(r.data)); }, []);
  useEffect(() => {
    const target = sessionStorage.getItem("tp_redirect");
    if (isSignedIn && target) {
      sessionStorage.removeItem("tp_redirect");
      navigate(target, { replace: true });
    }
  }, [isSignedIn, navigate]);

  return (
    <>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
      <Show when="signed-in">
        <Nav />
        <main className="max-w-6xl mx-auto px-4 py-10">
          <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
            <div>
              <h1 className="text-4xl font-black tracking-tight">Pick a category</h1>
              <p className="text-slate-600 mt-1">Study, replay, repeat. Your lives refresh daily at midnight.</p>
            </div>
          </div>
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3" data-testid="categories-grid">
            {cats.map((c) => <CategoryCard key={c.id} cat={c} />)}
          </div>
        </main>
      </Show>
    </>
  );
}
